<template>
    <div class="sj-footer">
        <div class="wrapper">
            <!-- <div class="contract">
                <div class="contract-item">
                    <img src="../assets/mail.svg" alt="">
                    <div class="contract-first-item">
                        <div class="mb10">
                            <span>商务合作</span>
                            <div>cuiyuanshan@360.cn</div>
                        </div>
                        <div class="">
                            <span>产品反馈</span>
                            <div>miguan@360.cn</div>
                        </div>
                    </div>
                    
                </div>
                <div class="contract-item">
                    <img src="../assets/location.svg" alt="">
                    <div class="">
                        <span>公司地址</span>
                        <div>北京市朝阳区酒仙桥路6号院国际电子城总部2号360大厦</div>
                    </div>
                </div>
                <div class="contract-item">
                    <img src="../assets/phone.svg" alt="">
                    <div class="">
                        <span style="font-size: 24px;">010-5244 7975</span>
                        <div>( 工作时间：周一至周五，10:00-19:00 )</div>
                    </div>
                </div>
            </div> -->
            <div class="copyright">
                <span>Copyright©2005-{{year}} 360.cn 版权所有 360互联网安全中心</span>
                <div>由360灵腾实验室、0Kee Team提供技术支持</div>
                <div @click="open" class="cp">京公网安备11000002000006号</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        open() {
            window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000006","_blank")
        }
    },
    computed: {
        year() {
            return new Date().getFullYear()
        }
    }
}
</script>
<style>
.sj-footer{
    background: #001F43;
}

.contract{
    height: 400px;
    display: flex;
    border-bottom: 1px solid rgba(255, 255,255, .15);
}
.contract:before, .wrapper:before{
  content: '';
  display:table;
}
.contract-item {
    flex: 1;
    display: flex;
    padding: 20px;
    text-align: left;
    border-right: 1px solid rgba(255, 255,255, .15);
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 24px;
    font-family: PingFangSC-Regular;
    margin: 100px 0;
}
.contract-item:last-child{
    border: none;
}
.contract-item img{
    margin: 0 30px;
    margin-top: 5px;
    height: 24px;
}
.copyright{
    padding: 30px;
    font-size: 12px;
    color: #779A93;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
}
</style>